import { Routes } from '@angular/router';
import { Josephus } from './josephus/josephus';
import { Tacitus } from './tacitus/tacitus';
import { PlinyTheYounger } from './pliny-the-younger/pliny-the-younger';
import { MaraBarSerapion } from './mara-bar-serapion/mara-bar-serapion';
import { PontiusPilate } from './pontius-pilate/pontius-pilate';
import { Phlegon } from './phlegon/phlegon';
import { Tertullian } from './tertullian/tertullian';
import { Thallus } from './thallus/thallus';
import { Suetonius } from './suetonius/suetonius';
import { Gospels } from './gospels/gospels';
import { Clement } from './clement/clement';
import { Celsus } from './celsus/celsus';
import { BeforeJesus } from './before-jesus/before-jesus';
import { Anachronisms } from './anachronisms/anachronisms';
import { Index } from './index';
import { ShroudOfTurin } from './shroud-of-turin/shroud-of-turin';
import { BcAd } from './bc-ad/bc-ad';
import { Stylometry } from './stylometry/stylometry';
import { Talmud } from './talmud/talmud';
import { LucianOfSamosata } from './lucian-of-samosata/lucian-of-samosata';
import { Manuscripts } from './manuscripts/manuscripts';
import { P52 } from './p52/p52';
import { Relics } from './relics/relics';
import { RonWyatt } from './ron-wyatt/ron-wyatt';
import { JustinMartyr } from './justin-martyr/justin-martyr';
import { Hcm } from './hcm/hcm';
import { Paul } from './paul/paul';
import { Ignatius } from './ignatius/ignatius';
import { Prophecies } from './prophecies/prophecies';
import { NotFound } from './not-found/not-found';
import { Irenaeus } from './irenaeus/irenaeus';
import { Polycarp } from './polycarp/polycarp';
import { Papias } from './papias/papias';
import { Eusebius } from './eusebius/eusebius';
import { Marcion } from './marcion/marcion';
import { DustinWhite } from './dustin-white/dustin-white';
import { Didache } from './didache/didache';
import { Full } from './full/full';
import { DieForALie } from './die-for-a-lie/die-for-a-lie';

export const routes: Routes = [
	{ path: '', component: Index },
	{ path: 'josephus', component: Josephus },	
	{ path: 'tacitus', component: Tacitus },
	{ path: 'pliny-the-younger', component: PlinyTheYounger },
	{ path: 'paul', component: Paul },
	{ path: 'mara-bar-serapion', component: MaraBarSerapion },
	{ path: 'pontius-pilate', component: PontiusPilate },
	{ path: 'phlegon', component: Phlegon },
	{ path: 'tertullian', component: Tertullian },
	{ path: 'thallus', component: Thallus },
	{ path: 'suetonius', component: Suetonius },
	{ path: 'justin-martyr', component: JustinMartyr },
	{ path: 'gospels', component: Gospels },
	{ path: 'prophecies', component: Prophecies },
	{ path: 'clement', component: Clement },
	{ path: 'celsus', component: Celsus },
	{ path: 'before-jesus', component: BeforeJesus },
	{ path: 'anachronisms', component: Anachronisms },
	{ path: 'shroud-of-turin', component: ShroudOfTurin },
	{ path: 'lucian-of-samosata', component: LucianOfSamosata },	
	{ path: 'talmud', component: Talmud },
	{ path: 'manuscripts', component: Manuscripts },
	{ path: 'p52', component: P52 },
	{ path: 'relics', component: Relics },
	{ path: 'calendar', component: BcAd },
	{ path: 'ron-wyatt', component: RonWyatt },
	{ path: 'historical-critical-method', component: Hcm },
	{ path: 'stylometry', component: Stylometry },
	{ path: 'ignatius', component: Ignatius },
	{ path: 'irenaeus', component: Irenaeus },
	{ path: 'polycarp', component: Polycarp },
	{ path: 'papias', component: Papias },
	{ path: 'eusebius', component: Eusebius },
	{ path: 'marcion', component: Marcion },
	{ path: 'dustin-white', component: DustinWhite },
	{ path: 'didache', component: Didache },
	{ path: 'die-for-a-lie', component: DieForALie },
	{ path: 'full', component: Full },
	{ path: 'everything', component: Full },	
	{ path: '**', component: NotFound },
];
